// ════════════════════════════════════════════════════════════════════════
//  Gemeinsame Grundlage für alles, was diese App druckt
//
//  Zwei Ausdrucke gibt es: die Code-Kärtchen und die Teilnahmeurkunde. Beide
//  entstehen im Browser – es gibt keinen Grund, für ein Blatt Papier etwas über
//  einen Server zu schicken.
//
//  HINWEIS ZU DEN FARBEN: Sonst definiert keine App eine Farbe selbst, alles
//  kommt aus @otto/design. Ein PDF ist aber kein CSS – es kennt keine
//  Custom Properties, sondern nur Zahlen. Deshalb stehen die Werte hier, und
//  zwar an EINER Stelle. Zwei Paletten in zwei Dateien liefen auseinander, ohne
//  dass es jemandem auffiele.
// ════════════════════════════════════════════════════════════════════════

import { rgb, type PDFFont } from "pdf-lib";

/** DIN A4 in Punkt, hochkant. Jeder Schuldrucker kann das ohne Nachfrage. */
export const A4 = { breite: 595.28, hoehe: 841.89 };

/** Seitenrand. */
export const RAND = 36;

export const farben = {
  /** Text. */
  ink: rgb(0.13, 0.14, 0.17),
  /** Beschriftungen und alles Beiläufige. */
  quiet: rgb(0.42, 0.44, 0.49),
  /** Linien: Schnittkanten, Namenslinien, Unterschriftslinien. */
  grey: rgb(0.72, 0.74, 0.78),
};

/**
 * WinAnsi deckt Deutsch ab, aber nicht alles: ein „–“ oder geschweifte
 * Anführungszeichen im Klassennamen lassen pdf-lib werfen. Lieber ersetzen als
 * die Lehrkraft mit einem Absturz stehen lassen, wenn ihre Klasse „3a – Füchse“
 * heißt.
 */
export function toWinAnsi(text: string): string {
  return text
    .replace(/[‘’‚‹›]/g, "'")
    .replace(/[“”„]/g, '"')
    .replace(/[–—]/g, "-")
    .replace(/…/g, "...")
    .replace(/\u00a0/g, " ") // geschütztes Leerzeichen, literal unsichtbar
    .replace(/[^\u0020-\u00ff]/g, "");
}

/**
 * Die größte Schriftgröße, in der der Text noch in die Breite passt.
 *
 * Auf dem Kärtchen steht rechts der QR-Code: „krebs-tuerkis-3318“ war in 17 pt
 * breiter als der Platz daneben und stiess an ihn. Auf der Urkunde gilt dasselbe
 * für lange Lehrgangs- und Schulnamen. Abschneiden käme in beiden Fällen nicht
 * in Frage – es sind der Code, den das Kind abtippt, und der Name der Schule.
 */
export function sizeToFit(
  font: PDFFont,
  text: string,
  maxWidth: number,
  preferred: number,
  min: number,
): number {
  let size = preferred;
  while (size > min && font.widthOfTextAtSize(text, size) > maxWidth) size -= 0.5;
  return size;
}

/** Dateiname aus freiem Text: im Downloadordner sonst nicht wiederzufinden. */
export function fileNamePart(text: string): string {
  return text.replace(/[^\w-]+/g, "-").replace(/^-|-$/g, "");
}
